// Third-party
import React from 'react';

// Components
import ComparisonBaseCell from '../ComparisonTable/ComparisonBaseCell';
import ComparisonScroller from '../ComparisonScroller';

// Utils
import { formatMessage } from '../../../../utils/i18n';
import ComparisonItem from '@/types/comparison-item';
import IncomeStreamScenario from '@/types/income-stream-scenario';

type Props = {
  years: string[];
  items: ComparisonItem[];
  editedComparisonItem?: ComparisonItem;
  scrollContainerRef?: HTMLElement;
  tablePaddingRef?: HTMLElement;
  editedIncomeStreamScenario?: IncomeStreamScenario;
  isEditPinned: boolean;
};

const IncomeStreamTableLabels = ({
  years,
  items,
  editedComparisonItem,
  editedIncomeStreamScenario,
  scrollContainerRef,
  tablePaddingRef,
  isEditPinned,
}: Props) => {
  const renderYears = () => (
    <>
      {years.map(year => (
        <ComparisonBaseCell className="year" key={`income-stream-${year}`}>
          <span className="label-container">
            <span className="label">{year}</span>
          </span>
        </ComparisonBaseCell>
      ))}
    </>
  );

  return (
    <div className="income-stream-table-labels">
      <div className="income-stream-labels-actions d-flex flex-column justify-content-center align-items-start">
        <ComparisonScroller
          items={items}
          editedComparisonItem={editedComparisonItem}
          scrollContainerRef={scrollContainerRef}
          tablePaddingRef={tablePaddingRef}
          editedIncomeStreamScenario={editedIncomeStreamScenario}
          isEditPinned={isEditPinned}
        />
      </div>

      <div className="income-stream-category years">
        <ComparisonBaseCell className="income-stream-category-header">
          <span className="label-container">
            <span className="label">{formatMessage('Comparison.IncomeStream.Year')}</span>
          </span>
        </ComparisonBaseCell>

        {renderYears()}

        <ComparisonBaseCell className="income-stream-category-header">
          <span className="label-container">
            <span className="label">{formatMessage('Comparison.IncomeStream.SourceOfDistributions')}</span>
          </span>
        </ComparisonBaseCell>

        {renderYears()}
      </div>
    </div>
  );
};

export default IncomeStreamTableLabels;
